import { useAppDispatch, useAppSelector } from '@/features';
import { changeSheet } from '@/features/slice/event/event-slice';
import { useGetRolePermissionQuery } from '@/features/slice/users/roles.permission/role-permission-api-slice';

export const useRolePermission = () => {
    const { sheetStatus: open } = useAppSelector((state) => state.eventSlice);
    const dispatch = useAppDispatch();
    const { data: rolesPermissionsData, isLoading } =
        useGetRolePermissionQuery('roles');
    const onOpenChange = () => {
        dispatch(changeSheet(!open));
    };

    return {
        open,
        isLoading,
        onOpenChange,
        rolesPermissionsData,
    };
};
